<template>
    <div @click="clickHandler" class="login-text-input">
        <div
            style="position: relative"
            class="login-input-row"
            :class="{
                '-error': errors.has(name)
            }"
        >
            <div
                :class="{
                    '-error': errors.has(name)
                }"
                class="login-input-label"
            >
                {{ $t(label) }}
            </div>
            <SelectorWrap
                ref="wrap"
                position="top"
                style="width: 100%"
                :disabled="passwordStrength == false"
                :timeout="500"
            >
                <template v-slot:selector>
                    <input
                        :data-cy="test_id"
                        :name="name"
                        @keydown.enter="$emit('enter')"
                        :autocomplete="autocomplete"
                        :placeholder="$t(placeholder)"
                        :type="inputType"
                        :value="value"
                        @blur="blur"
                        @focus="focused = true"
                        @input="onInput"
                        :test_id="test_id"
                        ref="input"
                        :class="{
                            '-error': errors.has(name)
                        }"
                    />
                </template>
                <template v-slot:body>
                    <PasswordStrength :password="value" />
                </template>
            </SelectorWrap>
            <TextButton
                v-if="type == 'password'"
                :label="showPasswordLabel"
                @click="togglePasswordVisibility"
            />
        </div>
        <div class="pre-login-error">
            {{ errorMessage }}
        </div>
    </div>
</template>
<script>
import { test_id } from '@/globalProps'
export default {
    components: {
        PasswordStrength: () => import('@/views/PreLoginView/PasswordStrength')
    },
    props: {
        passwordStrength: {
            type: Boolean,
            default: false
        },
        name: String,
        value: [String, Number],
        type: {
            type: String,
            default: 'text'
        },
        test_id,
        errors: Object,
        label: String,
        autocomplete: {
            type: String,
            default: 'nope'
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            focused: false,
            passwordVisible: false
        }
    },
    computed: {
        showPasswordLabel() {
            return this.inputType == 'password' ? 'BUTTON_SHOW' : 'LABEL_HIDE'
        },
        inputType() {
            return this.type == 'password' && !this.passwordVisible
                ? 'password'
                : 'text'
        },
        errorMessage() {
            return this.errors.getMessage(this.name)
        }
    },
    methods: {
        blur() {
            this.focused = false
            if (this.$refs.wrap) {
                this.$refs.wrap.bodyOpened = false
            }
        },
        togglePasswordVisibility() {
            this.passwordVisible = !this.passwordVisible
            this.$emit('visiblityToggled', this.passwordVisible)
        },
        clickHandler() {
            this.errors.clear(this.name)
        },
        onInput($event) {
            let value = $event.target.value
            if (value === null) {
                this.$emit('input', value)
                return
            }
            if (this.type === 'number') {
                value = parseInt(value)
            }
            this.$emit('input', value)
        }
    }
}
</script>
<style lang="scss" scoped>
.login-text-input {
    margin-top: 2rem;
    transition: $ease;
}
.login-input-label {
    color: #72838d;
    letter-spacing: 1.25px;
    font-family: $input-family;
    transition: $ease;
    position: absolute;
    pointer-events: none;
    font-size: 1rem;
    margin-left: -0.5rem;
    transform: translateY(-2.2rem);
    margin-left: -0.5rem;

    &.-error {
        color: $accent-red;
    }
}
.login-input-row {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    background: $view-background-alternative;
    border-radius: $input-radius;
    padding: 0.5rem;
    transition: $ease;
    border: solid 0.01rem transparent;

    &.-error {
        border-color: $accent-red;
    }
}
.pre-login-error {
    color: $accent-red;
    font-size: 0.8rem;
    margin-top: 0.4rem;
    margin-left: 0.5rem;
    font-family: $input-family;
    height: 0.5rem;
}
input {
    flex: 1;
    border: none;
    outline: none;
    padding: 0.5rem;
    box-sizing: border-box;
    letter-spacing: 1px;
    background: transparent;
    border-radius: $input-radius;
    padding-right: 2rem;
    font-family: $input-family;
    color: $input;
    transition: $ease;
    width: 100%;
    font-size: 1rem;

    &::placeholder {
        transition: $ease;
        color: $light;
    }

    &.-error {
        &::placeholder {
            color: $accent-red;
        }
    }
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
    border: none;
    font-family: $input-family;
    -webkit-text-fill-color: $input;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type='number'] {
    -moz-appearance: textfield;
}
</style>
